import { Fragment, FunctionalComponent, h } from 'preact';
import { Text } from 'preact-i18n';
import { WithStyles, withStyles } from '../../../../style';
import * as appStyles from '../../../../assets/global.scss';
import * as styles from './AwardContent.scss';
import { AwardInformationProps } from './interfaces/interface';
import { FinText } from '../../../../i18n';

type AwardRenderProps = AwardInformationProps & WithStyles;

export const AwardInformation: FunctionalComponent<AwardInformationProps> = withStyles(
  appStyles,
  styles
)(({ tx, isUpgradeView, isCorporateView, navigateToJoin, navigateToLogin }: AwardRenderProps) => {
  const isLoginView = !isUpgradeView && !isCorporateView;
  const translatableKey = isLoginView ? 'login' : isUpgradeView ? 'moveUpToFinnairPlus' : 'corporate';

  return (
    <Fragment>
      <div
        class={tx('award-container')}
        data-test-login={isLoginView}
        data-test-upgrade={isUpgradeView}
        data-test-corporate={isCorporateView}
      >
        <h2 class="nordic-blue-900-text font-heading-5">
          <FinText id={`award.${translatableKey}.title`} />
        </h2>
        <div class="font-body-1 ps-medium-t">
          <FinText id={`award.${translatableKey}.description`} />
        </div>
        <div class={tx(`${!isUpgradeView ? 'button-grid ' : ''}ps-medium-t`)}>
          <button
            data-test-login-button={!isUpgradeView}
            data-test-signup-button={isUpgradeView}
            class={tx('highButton ps-medium-y fill font-body-1', 'login-button')}
            onClick={isUpgradeView ? navigateToJoin : navigateToLogin}
          >
            <Text id={`award.${translatableKey}.${!isUpgradeView ? 'login' : 'signup'}`} />
          </button>
          {!isUpgradeView && (
            <button
              data-test-join-button
              class={tx('lightButton ps-medium-y font-body-1 fill', 'join-button')}
              onClick={navigateToJoin}
            >
              <Text id={`award.${translatableKey}.${isLoginView ? 'join' : 'signup'}`} />
            </button>
          )}
        </div>
      </div>
    </Fragment>
  );
});
